<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<TableServiceType />
			</div>
			<hr />
		</div>
	</MainLayout>
</template>

<script>
import MainLayout from "../layout/MainLayout";
import TableServiceType from "./Table.vue";
export default {
	components: {
		TableServiceType,
		MainLayout
	}
};
</script>

<style></style>
